import SnippetEditor from 'models/location/snippet_editor';

export default class NavigateToSnippet {
  constructor(context) {
    this.context = context;
  }

  run(snippetId) {
    this.context.router.navigateTo(SnippetEditor.create({ snippetId }));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/navigate_to_snippet.js